/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
// src/themes/theme1/utils/theme1Helpers.js
export const buildImageUrl = (imageUrl) => {
  if (!imageUrl || imageUrl === "" || imageUrl.includes("undefined")) {
    return "https://placehold.co/400x400.png?text=No+Image";
  }

  if (typeof imageUrl === "string" && imageUrl.startsWith("http")) {
    return imageUrl;
  }

  // الرابط الأساسي للسيرفر بدون /api
  const cleanBaseUrl = "https://madar-api.madar.iq";

  // معالجة مسار اللوجو الخاص: TenantDtl/ID/FileName -> uploads/ID/TenantDtl/FileName
  const parts = imageUrl.replace(/^\/+/, "").split("/");
  if (parts.length >= 3 && (parts[0] === "TenantDtl" || parts[0] === "Logo")) {
    const folder = parts[0];
    const fileId = parts[1];
    const fileName = parts.slice(2).join("/");
    return `${cleanBaseUrl}/uploads/${fileId}/${folder}/${fileName}`;
  }

  // التأكد من أن المسار يبدأ بـ /
  const path = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;
  return `${cleanBaseUrl}${path}`;
};

export const n = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export const safeText = (v) => (typeof v === "string" ? v.trim() : "");
